import * as yup from 'yup';

const shape = {
  corporateId: yup.string().required('form.validation.required'),
  userId: yup.string().required('form.validation.required'),
  password: yup.string().required('form.validation.required'),
  rememberMe: yup.boolean(),
};

export const loginHelpSchema = {
  corporateId: ['form.validation.required'],
  userId: ['form.validation.required'],
  password: ['form.validation.required'],
};
export const loginSchema = yup.object(shape);
